// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* GroupCard styles - imported from GroupsDashboardPage */
/* Styles for group-card are defined in GroupsDashboardPage.css */
/* This file exists for future component-specific overrides */
`, "",{"version":3,"sources":["webpack://./src/features/groups/GroupCard.css"],"names":[],"mappings":"AAAA,yDAAyD;AACzD,iEAAiE;AACjE,6DAA6D","sourcesContent":["/* GroupCard styles - imported from GroupsDashboardPage */\n/* Styles for group-card are defined in GroupsDashboardPage.css */\n/* This file exists for future component-specific overrides */\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
